export const required = (v: any) => !!v || "Pole jest wymagane";
